let locked = false;
let savedScrollY = 0;

export function disableBodyScroll(_element) {
  if (locked) return;
  locked = true;
  savedScrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.width = '100%';
}

export function clearAllBodyScrollLocks() {
  if (!locked) return;
  locked = false;
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, savedScrollY);
}
